import { Observable } from 'rxjs/internal/Observable';
import { APIService } from '@app/_services/api.service';
import { API_PATH } from '@app/app.constants';

export class NotificationsService {
    constructor(private api: APIService) {}

    getFirstParentNotification(): Observable<any> {
        return this.api.get(API_PATH.notifications.simple_notifications.first_parent_notification);
    }

    getCurrentUserNotifications(): Observable<any> {
        return this.api.get(API_PATH.notifications.current_user_notifications);
    }

    checkCurrentUserNotifications(): Observable<any> {
        return this.api.get(API_PATH.notifications.check_current_user_notifications);
    }

    getNotification(id): Observable<any> {
        return this.api.get(`${API_PATH.notifications.main}${id}`);
    }

    subscribeAppEvent(adId: number, subscribe: number): Observable<any> {
        return this.api.get(`${API_PATH.notifications.subscribe_app_event}${adId}/${String(subscribe)}`);
    }

    checkSubscribeAppEvent(adId: number): Observable<any> {
        return this.api.get(`${API_PATH.notifications.check_subscribe_app_event}${adId}`);
    }

    getWithoutNotification(): Observable<any> {
        return this.api.get(`${API_PATH.notifications.without_notification}`);
    }
}
